/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountName } from '../../models/account-name';

export interface AccountControllerGetAccountNames$Params {
}

export function accountControllerGetAccountNames(http: HttpClient, rootUrl: string, params?: AccountControllerGetAccountNames$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccountName>>> {
  const rb = new RequestBuilder(rootUrl, accountControllerGetAccountNames.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccountName>>;
    })
  );
}

accountControllerGetAccountNames.PATH = '/account/names/all';
